import { AppConfig, newAppConfig } from './create-app-config';

// TODO: resolve app config from parameter store on page load
/* istanbul ignore next */
export const config: AppConfig = newAppConfig();
